const DEFAULT_LOCALE = 'nl-NL'
const DEFAULT_CURRENCY = 'EUR'

type FormatOptions = {
  currency?: string
  locale?: string
}

export const formatPriceFromEuros = (
  amountInEuros?: number | null,
  options: FormatOptions = {},
) => {
  if (typeof amountInEuros !== 'number') return null

  const { currency = DEFAULT_CURRENCY, locale = DEFAULT_LOCALE } = options
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  })

  return formatter.format(amountInEuros)
}

